<template>
  <div id="container" class="text-center" style="text-align: center;">
    <vs-prompt buttonAccept="false" :is-valid="validateBookingNumber" accept-text="Verify" cancel-text="Cancel"
      title="Manage Booking" @cancel="val = ''" @close="close" :active.sync="showDialog">
      <div class="con-exemple-prompt">
        <span>Enter Booking Number</span>
        <!-- Updated input with validation -->
        <vs-input placeholder="booking number" v-model="bookingNumber" class="mt-3 w-full" required="true"
          color-danger="danger" @blur="bookingNumberBlurred = true" @input="bookingNumberBlurred = true" />
        <vs-alert class="mt-2" v-if="bookingNumberBlurred && !validateBookingNumber" color="danger"
          vs-icon="new_releases">
          Please Enter Booking Number
        </vs-alert>
      </div>
      <div class="flex justify-center" v-if="!showOptionButton">
        <vs-button v-if="bookingNumberBlurred && validateBookingNumber" @click="acceptAlert()" size="large"
          class="m-5 text-center">Verify</vs-button>
      </div>
      <div v-else class="flex justify-center p-5">
        <vs-button @click="updateReservation()" size="large" class="mr-2" style="width: auto;">UPDATE
          RESERVATION</vs-button>
        <vs-button @click="confirmBookingCancelation()" color="danger" style="width: auto;">CANCEL RESERVATION</vs-button>

      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { axiosMixin } from "@/mixin/axiosMixin";
import { alertMixin } from "@/mixin/alertMixin";
export default {
  mixins: [axiosMixin, alertMixin],
  props: {
    showManageBooking: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.showManageBooking;
      },
      set(value) {
        this.$emit('update:showManageBooking', value);
      }
    },
    validateBookingNumber() {
      return /^[a-zA-Z0-9-]{6,}$/.test(this.bookingNumber);
    },
  },
  data() {
    return {
      bookingNumber: "",
      showOptionButton: false,
      bookingNumberBlurred: false,
    };
  },
  watch: {
    showManageBooking(newVal) {
      if (newVal) {
        // Reset the states when the dialog is opened
        this.bookingNumber = "";
        this.showOptionButton = false;
        this.bookingNumberBlurred = false;
      }
    }
  },
  methods: {
    acceptAlert() {
      this.startLoading();
      this.aronPost("GetBookingByReference", { refNo: this.bookingNumber }, "", "")
        .then((response) => {
          if (response.data.status == "200") {
            this.$store.state.main.reservationData = response.data.reservation;
            this.$store.state.main.updateUiForReservation = false;
            this.showOptionButton = true;
          } else {
            this.errorAlert("Error", "Booking Number does not exist!");
            // Do not close the dialog if there is an error
          }
          this.stopLoading();
        })
        .catch((error) => {
          console.log("error:", error);
          this.errorAlert("Error", "An unexpected error occurred.");
          this.stopLoading();
        });
    }, 
    cancelBooking() {
      this.startLoading();
      this.aronPost("cancelBooking", { refNo: this.bookingNumber }, "", "")
        .then((response) => {
          if (response.data.status == "200") {
            this.successAlert("Success", "Booking Cancelled Successfully");
            this.$emit('update:showManageBooking', false); // Close the dialog only on success

          } else {
            this.errorAlert("Error", "Booking Number does not exist!");
            // Do not close the dialog if there is an error
          }
          this.stopLoading();
        })
        .catch((error) => {
          console.log("error:", error);
          this.errorAlert("Error", "An unexpected error occurred.");
          this.stopLoading();
        });
    },
    confirmBookingCancelation() {
      this.close();
      this.$vs.dialog({
        class: 'dialog-front', // Add this line
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        acceptText: "Yes",
        cancelText: "No",
        text: 'Are you sure you want to cancel your booking?',
        accept: this.cancelBooking,
        cancel: () => {
          this.showDialog = true;
        }
      })
    },
    updateReservation() {
      this.$store.state.main.updateUiForReservation = true;
      this.close();
    },
    close() {
      this.$emit('update:showManageBooking', false);
    },
    startLoading() {
      this.$vs.loading({
        container: "#container",
        scale: 0.6,
      });
    },
    stopLoading() {
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    // Additional methods...
  },
  mounted() {
    this.showOptionButton = false;
  }
};
</script>
<style>
.dialog-front,
.vs-dialog-overlay {
  z-index: 99999999 !important;
}
</style>
